import { useState } from "react";
import { useLocation, useNavigate, useSearchParams  } from "react-router-dom";
import { Box, Typography, TextField, Button } from "@mui/material";

export default function JoinCart() {
  const location = useLocation();
  const navigate = useNavigate();

 const [searchParams] = useSearchParams();

const cartIdFromUrl = searchParams.get("cartId");
const state = location.state || {};
/*
const {
  existingCart,
  companyCode,
  unitCode,
  tableId,
  serviceArea
} = location.state || {};*/

// 3. Merge (state > URL fallback)
const companyCode = state.companyCode || searchParams.get("code");
const unitCode = state.unitCode || searchParams.get("unit");
const tableId = state.tableId || searchParams.get("id");
const serviceArea = state.serviceArea || searchParams.get("serviceArea");
//const existingCart = state.existingCart || null;
const existingCart = state.existingCart || { cartId: cartIdFromUrl };

// cartId always from URL (safe)

  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");

  const handleJoin = () => {
  const actualCartId = existingCart?.cartId || cartIdFromUrl;

  if (!actualCartId) {
    setError("Cart not found. Please scan again.");
    return;
  }

  if (otp === actualCartId) {
    sessionStorage.setItem("cartId", actualCartId);

    navigate(
      `/customer/menu?code=${companyCode}&unit=${unitCode}&id=${tableId}&serviceArea=${serviceArea}&cartId=${actualCartId}`,
      {
        state: {
          cartId: actualCartId,
          companyCode,
          unitCode,
          tableId,
          serviceArea
        }
      }
    );
  } else {
    setError("Invalid OTP. Please ask your group.");
  }
};

  const handleNewGroup = () => {
    sessionStorage.removeItem("cartId");

   /* navigate(
      `/customer/details?code=${companyCode}&unit=${unitCode}&id=${tableId}&serviceArea=${serviceArea}`
    );*/
   navigate(
  `/customer/details?code=${companyCode}&unit=${unitCode}&id=${tableId}&serviceArea=${serviceArea || ''}`,
  {
    state: {
      companyCode,
      unitCode,
      tableId,
      serviceArea,
      isCustomer: true,
      forceNewCart: true,
      existingCart: null // 🚨 IMPORTANT
    },
  }
);
  };

  return (
    <Box sx={{ maxWidth: 400, mx: "auto", mt: 5 }}>
      <Typography variant="h5" textAlign="center" mb={2}>
        Join Existing Order
      </Typography>

      <Typography variant="body2" textAlign="center" mb={3}>
        Enter OTP from your group to join the same order
      </Typography>

      <TextField
        fullWidth
        label="Enter OTP"
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
      />

      {error && (
        <Typography color="error" mt={1}>
          {error}
        </Typography>
      )}

      <Button fullWidth variant="contained" sx={{ mt: 2 }} onClick={handleJoin}>
        Join Group
      </Button>

      <Button fullWidth sx={{ mt: 1 }} onClick={handleNewGroup}>
        Start New Order
      </Button>
    </Box>
  );
}